<template>
  <div class="list">
    <van-tabs v-model="activeName" type="card" @change="tabsChange">
      <!-- 二级tabs 商品大类 -->
      <van-tab v-for="good in goodList" :key="good.id" :title="good.categoryName" :name="good.id">
        <!-- 列表 -->
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-card v-for="(item, index) in data" :key="index" :title="item.goodsName" thumb="https://img01.yzcdn.cn/vant/ipad.jpeg">
              <template #price>
                ￥<span>{{ item.price }}</span
                >起
              </template>
              <template #footer>
                <van-button type="primary" size="small" @click="subscribe">订阅</van-button>
              </template>
            </van-card>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: 0,
        data: [],
        loading: false,
        finished: false,
        refreshing: false,
        mainType: this.$store.state.newsKiosk.mainType,
        goodList: [],
        page: {
          pageNo: 1,
          pageSize: 50
        }
      }
    },
    mounted() {
      this.goodcategory()
    },
    watch: {
      activeName(newValue, oldValue) {}
    },
    methods: {
      /**
       * todo 切换标签回调方法
       */
      tabsChange(actived) {
        this.loading = true
        this.getlist(actived).then((res) => {
          this.loading = false
        })
      },
      /**
       * todo 商品列表
       */
      getlist(id) {
        let params = {
          ...this.page,
          pageCategoryId: this.mainType,
          goodsCategoryId: id
        }
        return new Promise((resolve, reject) => {
          this.$api.goodList.getlist(params).then((res) => {
            let { result, count } = res
            if (count) {
              if (Array.isArray(result)) {
                this.data = result
                resolve()
              }
            } else {
              reject()
            }
          })
        })
      },
      /**
       * todo 拉取二级大类商品分类方法
       */
      goodcategory() {
        return this.$api.goodList.goodcategory({ pageCategoryId: this.mainType }).then((res) => {
          let { result } = res
          if (Array.isArray(result)) {
            this.goodList = result
            this.activeName = this.goodList[0].id
          }
        })
      },
      /**
       * todo 点击列表订阅按钮
       * @author 付震
       */
      subscribe(row) {
        this.$router.push({ path: '/subscribeDetail', query: { ...row } })
      },
      /**
       * todo 懒加载接口方法
       * @author 付震
       */
      onLoad() {
        if (this.refreshing) {
          this.refreshing = false
        }
        this.loading = true
        this.getlist(this.activeName)
          .then((res) => {
            this.loading = false
          })
          .catch(() => {
            this.finished = true
          })
      },
      /**
       * todo 下拉拉取方法
       * @author 付震
       */
      onRefresh() {
        // 清空列表数据
        this.finished = false

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true
        this.onLoad()
        // this.getlist(this.activeName).then(() => {
        //   this.loading = false
        //   this.refreshing = false
        // })
      }
    }
  }
</script>

<style lang="scss" scoped></style>
